import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiService } from '../Services/api.service';
import { AlertPadelService } from '../Services/alert.service';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const apiService = inject(ApiService);
  const alertService = inject(AlertPadelService);
  const router = inject(Router);

  // Get the token from the API service
  const token = apiService.getTokenValue();

  // Get the current language directly from localStorage instead of injecting LanguageService
  const currentLang = localStorage.getItem('language') || 'ar';

  // Add headers
  const headers: Record<string, string> = {};

  // Add auth token if available
  if (token) {
    try {
      // Parse the token if it's stored as JSON string
      let tokenValue = token;
      // Format the Authorization header correctly
      headers['Authorization'] = `Bearer ${tokenValue}`;

    } catch (e) {
      console.error('Error setting authorization header:', e);
    }
  }

  // Add language header
  headers['Accept-Language'] = currentLang;

  // Clone the request with new headers
  const authReq = req.clone({
    setHeaders: headers,
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('customerId');
        router.navigate(['/']);
      }
      return throwError(error);
    })
  );
};
